// extracted by mini-css-extract-plugin
export default {"modal":"PopupStyles_modal__CGuqD","modal__body":"PopupStyles_modal__body__bOEmy","modal_close":"PopupStyles_modal_close__R1c4R"};